export function RastreamentoResourceFactory($resource, URL, PATH, URLAPIPEDIDO, URL_RASTREAMENTO, URLAPIPEDIDO_REPLICA, URLAPICLIENTE) {
  return $resource(URL + PATH + '/orders/:orderId', {
    orderId: '@_orderId'
  }, {
    getRastreio: {
      method: 'GET',
      url: URL_RASTREAMENTO + '/items/:idRastreamento/tracking?perfil=CLIENTE',
      params: {
        idRastreamento: '@idRastreamento'
      }
    },
    putEmailDestinatario: {
      method: 'PUT',
      url: URLAPIPEDIDO + '/v1/atualizarEmailDestinatario'
    },
    getDadosVolumes: {
      method: 'GET',
      url: URLAPIPEDIDO_REPLICA + '/v1/encomendas/volumes?codigoRastreamento=:idRastreamento',
      params: {
        idRastreamento: '@idRastreamento'
      },
      isArray: true,
      transformResponse: function(data, header){
        return JSON.parse(data);
      }
    },
    getComprovanteEntrega: {
      method: 'GET',
      url: URLAPICLIENTE + '/comprovanteEntregaEncomenda/:idEncomenda',
      params: {
        idEncomenda: '@idEncomenda'
      },
    },
  });
}
